export const  ArrowUpIcon = (
    <svg width="30" height="18" viewBox="0 0 30 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M0.473431 15.2415C-0.157597 15.8726 -0.157597 16.8957 0.473431 17.5267C1.10517 18.1584 2.12967 18.1576 2.7604 17.5249L15.0002 5.24607L27.2399 17.5249C27.8707 18.1576 28.8952 18.1584 29.5269 17.5267C30.1579 16.8957 30.1579 15.8726 29.5269 15.2415L15.0002 0.714817L0.473431 15.2415Z" fill="white"/>
    </svg>
)


